import { LogLevel } from '@azure/msal-browser';

// Helper function to get runtime config with fallbacks
const getConfig = (key, buildTimeEnv, defaultValue) => {
  // Priority: 1. Runtime config, 2. Build-time env, 3. Default
  return (
    (window.ENV && window.ENV[key] !== 'REPLACE_AT_RUNTIME' ? window.ENV[key] : null) ||
    buildTimeEnv ||
    defaultValue
  );
};

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: getConfig(
      'AZURE_CLIENT_ID',
      process.env.REACT_APP_AZURE_CLIENT_ID,
      'your-client-id'
    ),
    authority: getConfig(
      'AZURE_AUTHORITY',
      process.env.REACT_APP_AZURE_AUTHORITY,
      'https://login.microsoftonline.com/your-tenant-id'
    ),
    redirectUri: getConfig(
      'REDIRECT_URI',
      process.env.REACT_APP_REDIRECT_URI,
      'http://localhost:3000'
    ),
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Add scopes for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphGroupsEndpoint: 'https://graph.microsoft.com/v1.0/me/memberOf',
};

// Define your Azure AD security groups
export const securityGroups = {
  adminGroupId: getConfig(
    'ADMIN_GROUP_ID',
    process.env.REACT_APP_ADMIN_GROUP_ID,
    'your-admin-group-id'
  ),
  userGroupId: getConfig(
    'USER_GROUP_ID',
    process.env.REACT_APP_USER_GROUP_ID,
    'your-user-group-id'
  ),
};

// Role definitions
export const roles = {
  ADMIN: 'admin',
  USER: 'user',
};
